import {pageInfo, exportData, qrCodeDetails, updateQrCode} from '../api';
import {Message} from 'element-ui';
import { plant ,getQrCodeDate} from '../../../../../api'

const qrCode = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj:[],
    exportObj: [],
    qrCodeDetailObj: null,
    updateQrCodeObj: null,
    qrCodeObj: [],
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = (data.obj || []).map(item => ({ key: item.plantName, value: item.plantCode }))
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    QRCODE_DETAILS(state, data) {
      state.qrCodeDetailObj = data;
    },
    UPDATE_QRCODE(state, data) {
      state.updateQrCodeObj = data;
    },

    GET_QRCODE_DATA(state, data) {
      state.qrCodeObj = data;
    },

  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async qrCodeDetails({commit}, obj) {
      let resp = await qrCodeDetails(obj);
      commit('QRCODE_DETAILS', resp);
    },
    async updateQrCode({commit}, obj) {
      let resp = await updateQrCode(obj);
      commit('UPDATE_QRCODE', resp);
    },
    async getQrCodeDate({commit}, obj) {
      let resp = await getQrCodeDate(obj);
      commit('GET_QRCODE_DATA', resp);
    },
  }
}
export default qrCode



// WEBPACK FOOTER //
// ./src/page/bd/qc/qrCode/store/qrCode.store.js